import { useEffect, useState } from "react";
import { getBookedAuditionees, setCastingChoice } from "../../../../CastingBotFirebase";
import SubTabNoData from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabNoData";
import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons";
import SectionLoader from "../../../../_shoru_shared_library/loaders/SectionLoader";
import SubTabSelectTable from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSelectTable";

function InputChoicesTab(props) {

  function filterForRecalls(x) {return x.recalled}

  const userData = props.userData;
  const castingData = props.extraData;
  const setCastingData = props.setExtraData;
  const roles = castingData.roles;

  const header = ['1', '2', '3', '4', '5']
  const [recallees, setRecallees] = useState(null);
  const [editingEnabled, setEditingEnabled] = useState(true);

  const handleChange = async(roleId, r, c, value) => {
    console.log("Changed value for " + roleId + " at " + r + ",", + c + " = " + value)
    setEditingEnabled(false);
    await setCastingChoice(roleId, c, value, userData.active_organisation_id, castingData.uid, setCastingData);
    setEditingEnabled(true);
  }

  // Get auditionee data
  useEffect(() => {
    getBookedAuditionees(castingData.slots.filter(filterForRecalls), userData.active_organisation_id, setRecallees);
    // eslint-disable-next-line
  }, []);

  if(recallees === null) return <SectionLoader />

  let choiceTables = roles.map((role) => {
    const options = _parseToSelectTable(recallees, castingData.slots.filter(filterForRecalls), role);
    
    return (
      <SubTabSelectTable 
        addNull 
        tableKey={role.id} 
        title={role.name} 
        header={header} 
        options={options} 
        values={[role.choices]} 
        setValue={handleChange} 
        editingEnabled={editingEnabled}
      />
    )
  })

  if(roles.length > 0) 
  {
    return (
      <SubTabParent passData={props}>
        {choiceTables}
      </SubTabParent>
    )
  }
  else 
  {
    return (
      <SubTabNoData 
        icon={faPlusSquare} 
        title='No Roles' 
        description='Add roles to see them here' 
      />
    )
  }

}

export default InputChoicesTab;



const _parseToSelectTable = (recallees, slots, role) => {

  slots.sort((a,b) => {return a.auditionee_id > b.auditionee_id? 1 : -1})
  var recalleesArray = []

  slots.forEach((slot) => {

    // If the role has not been added to any groups, or has been added to a group for this role, flag it to be included in the options
    var include = (slot.notes.recall_verdicts.length === 0)
    slot.notes.recall_verdicts.forEach((recall) => {
      if(recall.role_id === role.id.toString()) include = true;
    })

    if(include)
    {
      var recallee = null;
      recallees.every((r) => {
        if(r.uid === slot.auditionee_id) { recallee = r; return false; }
        else { return true; }
      })

      recalleesArray = [...recalleesArray, (
        <option value={recallee.uid}>{recallee.name}</option>
      )]
    }

  })

  return recalleesArray;
}